<template>
  <v-snackbar v-model="isOpen" :timeout="timeout" bottom>
    {{ text }}
    <template v-if="action" v-slot:action="{ attrs }">
      <v-btn v-bind="attrs" text @click="onSnackbarActionClick">
        {{ action }}
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script>
import eventBus, { OPEN_SNACKBAR } from '../util/event-bus';

export default {
  name: 'Snackbar',

  data() {
    return {
      text: '',
      url: '',
      callback: null,
      action: '',
      timeout: 6000,
      isOpen: false,
    };
  },

  created() {
    eventBus.$on(OPEN_SNACKBAR, (options) => {
      if (typeof options === 'string') {
        this.text = options;
        this.action = '';
        this.callback = null;
        this.url = '';
        this.timeout = 6000;
        this.isOpen = true;
      } else if (options.isOpen === false) {
        // for turning off snackbar manually
        this.isOpen = false;
      } else {
        this.text = options.text ? options.text : '';
        this.action = options.action ? options.action : '';
        this.callback = options.callback ? options.callback : null;
        this.url = options.url ? options.url : '';
        this.timeout = options.timeout ? options.timeout : 6000;
        this.isOpen = true;
      }
    });
  },

  methods: {
    onSnackbarActionClick() {
      if (this.url) {
        this.$router.push(this.url);
      }
      if (this.callback) {
        this.callback();
      }
      this.isOpen = false;
    },
  },
};
</script>
